"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/IncompatibleBrowser.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');


var _VideoCall = require('web/components/VideoCall');
var _RoomHeader = require('web/components/VideoCall/RoomHeader'); var _RoomHeader2 = _interopRequireDefault(_RoomHeader);






// Was a plain class inside connect(): memo keeps connect's props bail-out.
const IncompatibleBrowserScreen = ({
  onRoomLinkCopy,
  openMobileMoreOptionsModal,
}) => {
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)

  const handleOpenMobileMoreOptionsModal = _react.useCallback.call(void 0, () =>
    openMobileMoreOptionsModal({ isSettingsLinkEnabled: false }), [openMobileMoreOptionsModal])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_RoomHeader2.default, {
        roomName: roomName,
        roomLink: roomLink,
        onRoomLinkCopy: onRoomLinkCopy,
        openMobileMoreOptionsModal: handleOpenMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      )
      , _react2.default.createElement(_VideoCall.IncompatibleBrowser, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 35}} )
    )
  )
}

exports. default = _react.memo.call(void 0, IncompatibleBrowserScreen)
